// src/components/StarRating.js
// Displays a static star rating, or an interactive selector when onChange is passed.

import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ rating, onChange, size = 18 }) => {
    const interactive = typeof onChange === 'function';
    const stars = [1, 2, 3, 4, 5];

    return (
        <div className="flex items-center gap-1" role={interactive ? 'radiogroup' : undefined} aria-label="Rating">
            {stars.map((value) => (
                <button
                    key={value}
                    type="button"
                    disabled={!interactive}
                    onClick={() => onChange?.(value)}
                    aria-label={`${value} star${value > 1 ? 's' : ''}`}
                    className={interactive ? 'cursor-pointer' : 'cursor-default'}
                >
                    <Star
                        size={size}
                        className={value <= rating ? 'fill-[#CEAC8F] text-[#CEAC8F]' : 'text-muted-foreground/40'}
                    />
                </button>
            ))}
        </div>
    );
};

export default StarRating;
